import React from 'react';
import {
  useChooseIncomeCategoriesLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ChooseIncomeCategories/useChooseIncomeCategoriesLayout';

function ChooseIncomeCategoriesLayout() {
  const ChooseIncomeCategoriesLayoutComponent = useChooseIncomeCategoriesLayout();

  return (
    <ChooseIncomeCategoriesLayoutComponent />
  );
}

ChooseIncomeCategoriesLayout.propTypes = {};

ChooseIncomeCategoriesLayout.defaultProps = {};

export { ChooseIncomeCategoriesLayout };
